import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IssueConfigModel } from './issueconfig-model';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../../apimethods/api-method';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';

declare var $;

@Component({
  selector: 'app-issueconfig',
  templateUrl: './issueconfig.component.html',
  styleUrls: ['./issueconfig.component.css']
})
/** issueconfig component*/
export class IssueconfigComponent implements OnInit {
  modelItem: IssueConfigModel = new IssueConfigModel();
  JournalList: JSON; YearList: JSON;
  dataTable: any;
  dtOptions: any;
  tableData = [];
  @ViewChild('dataTable', { static: false }) table;
  dataSet: any;
  showModal: boolean;
  popUpButtonText: string = "Add";
  title: string = "Add Issue Config details";
  Txt_Volume: string = ''; Txt_Issue: string = ''; Txt_Pages: string = ''; Txt_AnnualBudget :string='';
  file: any;
  fileBase64: any;
  /** issueconfig ctor */
  constructor(private router: Router) {
    this.loadGeneralmethod();
  }
  ngOnInit() {
    $("#ddlJournalList").select2({ dropdownParent: ".card-body" });

    $('#ddlJournalListPop').select2({
      placeholder: "Select Journal",
      dropdownParent: "#popupbody"
    });
    $('#ddlJournalListPop').val([]).trigger('change');

    $('#ddlYearListPop').select2({
      placeholder: "Select Year",
      dropdownParent: "#popupbody"
    });
    $('#ddlYearListPop').val([]).trigger('change');

    $('#ddlSignatureCount').select2({
      placeholder: "Select SignatureCount",
      dropdownParent: "#popupbody"
    });
    $('#ddlSignatureCount').val([]).trigger('change');

    $('#ddlIssuetoPrint').select2({
      placeholder: "Select Issue to Print",
      dropdownParent: "#popupbody"
    });
    $('#ddlIssuetoPrint').val([]).trigger('change');

    $('#ddlIssueOnline').select2({
      placeholder: "Select Issue Online",
      dropdownParent: "#popupbody"
    });
    $('#ddlIssueOnline').val([]).trigger('change');

    $('#ddlTOConCover').select2({
      placeholder: "Select TOConCover",
      dropdownParent: "#popupbody"
    });
    $('#ddlTOConCover').val([]).trigger('change');

    $('#ddlIndex').select2({
      placeholder: "Select Index",
      dropdownParent: "#popupbody"
    });
    $('#ddlIndex').val([]).trigger('change');

    $('#ddlArticleStart').select2({
      placeholder: "Select Article Start",
      dropdownParent: "#popupbody"
    });
    $('#ddlArticleStart').val([]).trigger('change');

    $('#ddlIOGNT').select2({
      placeholder: "Select IOG NT",
      dropdownParent: "#popupbody"
    });
    $('#ddlIOGNT').val([]).trigger('change');


    /*$("#ddlJournalListPop").select2({ dropdownParent: "#myModal" });*/
  }
  loadGeneralmethod() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <IssueConfigModel>data["IssueConfig"];
        this.LoadJournalList();
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  // Load Journal List
  LoadJournalList() {
    if (this.modelItem.JournalListAPI != '') {
      ApiMethod.getMethod(this.modelItem.JournalListAPI + '/' + localStorage.aPubID).subscribe(
        result => {
          this.JournalList = JSON.parse(JSON.stringify(result.aJrnlList));
          this.YearList = JSON.parse(JSON.stringify(result.aYearList));
          this.GetIssueConfigList();
        },
        error => {
          ngswal("Warning !", error.message, "warning");
        });
    }
  }

  GetIssueConfigList(): void {
    $("#LoadingImage").show();
    var postData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      JournalId: $('#ddlJournalList').val(),
    };
    ApiMethod.postMethod(this.modelItem.LoadDataList, postData).subscribe(
      resonse => {
        this.dataSet = JSON.stringify(resonse.aDataitem); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);


        //Dynamic datable
        let acolList = resonse.aColList;

        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 220);
        dataItem.modulename = 'IssueConfigModule';

        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
      }
    );

  }

  show() {
    this.ClearData()
    /*$('#popupbody').css('height', (GlobalConstants.size.height - 20));*/
    this.showModal = true; // Show-Hide Modal Check
    if (localStorage.aEID != 0) {
      this.title = "Update Issue Config details";// Dynamic Data
      this.popUpButtonText = "Update";
      $("#LoadingImagePopup").show();
      ApiMethod.getMethod(this.modelItem.IssueConfigDetails + '/' + localStorage.aEID).subscribe(
        result => {
          let itemdata = result.itemData;
          $('#ddlJournalListPop').val(itemdata.JournalID).change();
          $('#ddlYearListPop').val(itemdata.IssueYear).change();
          $('#Txt_Volume').val(itemdata.Volume);
          $('#Txt_Issue').val(itemdata.Issue);
          $('#Txt_Pages').val(itemdata.PagePerIssue);
          $('#ddlSignatureCount').val(itemdata.SignatureCount).change();
          $('#ddlIssuetoPrint').val(itemdata.IssueToPrint).change();
          $('#ddlIssueOnline').val(itemdata.IssueOnline);
          $('#ddlTOConCover').val(itemdata.TOCOnCover);
          $('#ddlIndex').val(itemdata.Index).change();
          $('#Txt_SpineWidth').val(itemdata.SpineWidth);
          $('#Txt_VolumeStartFolio').val(itemdata.VolumeStartFolio);
          $('#ddlArticleStart').val(itemdata.ArticleStart).change();
          $('#Txt_AnnualBudget').val(itemdata.AnnualBudget);
         
          $('#ChkEditor').prop('checked', itemdata.IssueFlow_Editor).change();
          $('#ChkPE').prop('checked', itemdata.IssueFlow_PE).change();
          $('#Chk_BackLogIssue').prop('checked', itemdata.BackLogIssue).change();


          $('#ddlIOGNT').val(itemdata.IOGNT).change();
          $('#Txt_GenericInstruction').val(itemdata.GenericInstruction);

          $("#LoadingImagePopup").hide();
        },
        error => {
          ngswal("Warning !", error.message, "warning");
          $("#LoadingImagePopup").hide();
        });


    }
  }
  // Bootstrap Modal Close event

  ClearData(): void {
    $('#ddlJournalListPop').val(0).change();
    $('#ddlYearListPop').val(0).change();
    $('#Txt_Volume').val('');
    $('#Txt_Issue').val('');
    $('#Txt_Pages').val('');
    $('#ddlSignatureCount').val(0).change();
    $('#ddlIssuetoPrint').val('');
    $('#ddlIssueOnline').val('');
    $('#ddlTOConCover').val('');
    $('#ddlIndex').val('');
    $('#Txt_SpineWidth').val('');
    $('#Txt_VolumeStartFolio').val('');
    $('#Txt_AnnualBudget').val('');
    $('#ddlArticleStart').val(0).change();
    $('#ddlIndex').val('');
    $('#ChkEditor').prop('checked', false);
    $('#ChkPE').prop('checked', false);
    $('#Chk_BackLogIssue').prop('checked', false);
    $('#ddlIOGNT').val('');
    $('#Txt_GenericInstruction').val('');
  }

  hide(): void {
    localStorage.aEID = 0;
    this.showModal = false;
  }

  UpdateData(): void {
    if ($('#ddlJournalListPop').val() == 0) {
      ngswal("Warning !", this.modelItem.JournalWarning, "warning");
    }
    else if ($('#ddlYearListPop').val() == 0) {
      ngswal("Warning !", this.modelItem.YearWarning, "warning");
    }
    else if ($('#Txt_Volume').val() == 0 || $('#Txt_Volume').val().trim() == '') {
      ngswal("Warning !", this.modelItem.VolumeWarning, "warning");
    }
    else if ($('#Txt_Issue').val() == 0 || $('#Txt_Issue').val().trim() == '') {
      ngswal("Warning !", this.modelItem.IssueWarning, "warning");
    }
    else {
      $("#LoadingImagePopup").show();
      var postData = {
        ID: localStorage.aEID,
        JournalId: $('#ddlJournalListPop').val(),
        IssueYear: $('#ddlYearListPop').val(),
        Volume: $('#Txt_Volume').val(),
        Issue: $('#Txt_Issue').val(),
        PagePerIssue: $('#Txt_Pages').val(),
        SignatureCount: $('#ddlSignatureCount').val(),
        IssueToPrint: $('#ddlIssuetoPrint').val(),
        IssueOnline: $('#ddlIssueOnline').val(),
        TOCOnCover: $('#ddlTOConCover').val(),
        Index: $('#ddlIndex').val(),
        SpineWidth: $('#Txt_SpineWidth').val(),
        VolumeStartFolio: $('#Txt_VolumeStartFolio').val(),
        ArticleStart: $('#ddlArticleStart').val(),
        IssueFlow_Editor: ($("#ChkEditor").prop('checked') ? 1 : 0),
        IssueFlow_PE: ($("#ChkPE").prop('checked') ? 1 : 0),
        IOGNT: $('#ddlIOGNT').val(),
        GenericInstruction: $('#Txt_GenericInstruction').val(),
        AnnualBudget: $('#Txt_AnnualBudget').val(),
        BackLogIssue: ($("#Chk_BackLogIssue").prop('checked') ? 1 : 0),
        UpdatedBy: localStorage.aLoginID,
      };
      ApiMethod.postMethod(this.modelItem.UpdateIssueConfig, postData).subscribe(
        resonse => {
          if (resonse.responseitem.includes('Failed'))
            ngswal("Failed !", resonse.responseitem, "warning");
          else {
            ngswal("Update Status !", resonse.responseitem, "success");
            this.hide();
            this.GetIssueConfigList();
          }
          $("#LoadingImagePopup").hide();
        },
        error => {
          $("#LoadingImagePopup").hide();
        }
      );
    }
  }

  onuploadSelected(fileInput: any) {

    var ext = $('#doc_Importfile').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['xlsx']) == -1) {
      $('#doc_Importfile').val("");
      ngswal("Failed !", "Invalid File format \n Please Refer Sample File", "warning");
      return false;
    } else if (fileInput.target.files[0].size > 52428800) {
      $('#doc_Importfile').val("");
      ngswal("Failed !", "Please upload File less than 50MB", "warning");
      return;
    } else {
      this.file = fileInput.currentTarget.files[0];
      if (fileInput.currentTarget.files[0]) {

        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.fileBase64 = null;
          this.fileBase64 = e.currentTarget.result;
        }
        fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
        this.confirmation();
      }
    }
  }
  // Confirmation for Test allocation Upload
  confirmation() {
    if ($('#doc_Importfile').val() == "") {
      $('#doc_Importfile').val("");
      ngswal("Failed !", "Please upload File..!", "warning");
      return;
    }
    ngswal({
      title: "File Upload Confirmation",
      text: this.file.name + "\nAre you sure Submit File?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {

        if (isConfirm) {
          $('#fileupload').trigger("click");
        } else {
          $('#doc_Importfile').val("");
          return false;
        }
      });
  };
  fileupload() {
    $("#LoadingImage").show();
    var filedetails = {
      ID: localStorage.aEID,
      UserName: localStorage.aLoginName,
      fileName: this.file.name,
      fileSize: this.file.size,
      fileAsBase64: this.fileBase64,
    }
    ApiMethod.postMethod(this.modelItem.UploadImpoertfileAPI, filedetails).subscribe(
      response => {
        $("#LoadingImage").hide();
        $('#doc_Importfile').val("");
        this.fileBase64 = "";
        if (response.status == "Success") {
          ngswal({
            position: "top-end",
            type: "success",
            title: "Uploaded Successfully!",
            text: response.message,
            showConfirmButton: true
          });
        } else {
          ngswal({
            position: "top-end",
            type: "error",
            title: "Upload Failed!",
            text: response.message,
            showConfirmButton: true

          });
        }
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.error.Message, "error");
      });
  }
  downloadFile() {
    $("#LoadingImageReopen").show();
    ApiMethod.Downloadfile(this.modelItem.DownloadsamplefileAPI);
    $("#LoadingImageReopen").hide();
  }
}
